/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  usersbank:[],
  useroldcredit:[],
  usercredit:[],
  banners:[],
  banner_select:{
    name:'',
    order:'',
    createdate:'',
    detail:'',
  },
  logs:[],
  sites:[],
  master:{
    firstname:'',
    lastname:'',
    email:'',
    password:'',
    manage:false,
    admin:false,
    sale:false
  },
  company: [],
  department: [],
  userOption:[],
  userOptionTrueWallet:[],
  users: [],
  user_select:[],
  user_select2:[],
  popup:false,
  popup2:false,
  popupcredit:false,
  employee:[],
  depositTotal:0,
  withdrawTotal:0,
  total:0,
  totalBonus:0,
  history:[],
  user:{
    avatar_path:'https://image.freepik.com/free-vector/businessman-profile-cartoon_18591-58479.jpg',
    avatar:'https://image.freepik.com/free-vector/businessman-profile-cartoon_18591-58479.jpg',
    code:null,
    email:null,
    firstname:null,
    lastname:null,
    job_title:null,
    manager:null,
    mobile:null,
    role:null,
    status:null,
    password:null,
    location:{
      add_line_1:null,
      add_line_2:null,
      subdistrict:null,
      district:null,
      province:null,
      post_code:null,
    },
    social_links:{
      twitter:null,
      facebook:null,
      instagram:null,
      github:null,
      line:null,
      slack:null,
    },
  },
  userdefault:{
    avatar_path:'https://image.freepik.com/free-vector/businessman-profile-cartoon_18591-58479.jpg',
    avatar:'https://image.freepik.com/free-vector/businessman-profile-cartoon_18591-58479.jpg',
    code:null,
    email:null,
    firstname:null,
    lastname:null,
    job_title:null,
    manager:null,
    mobile:null,
    role:null,
    status:null,
    password:null,
    location:{
      add_line_1:null,
      add_line_2:null,
      subdistrict:null,
      district:null,
      province:null,
      post_code:null,
    },
    social_links:{
      twitter:null,
      facebook:null,
      instagram:null,
      github:null,
      line:null,
      slack:null,
    },
  },
}
